import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IEventsDashboardData, ITimeRangeParams } from 'src/apis/dashboard/dashboard.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardEventsKey = 'get-dashboard-events';

export const useDashboardEventsHook = (
  params?: ITimeRangeParams,
  options?: UseQueryOptions<IEventsDashboardData, TQueryError>
): UseQueryResult<IEventsDashboardData, TQueryError> => {
  const { getEventsDashboardDataNew } = useDashboardService();

  return useQuery<IEventsDashboardData, TQueryError>({
    queryKey: [getDashboardEventsKey, params],
    queryFn: () => getEventsDashboardDataNew(params),
    enabled: true,
    ...options,
  });
};
